var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpedientesBalken(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.93 24.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9f9f9d;stroke-width:0px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.92,6.86s0-.02,0-.03c0-.04,0-.07,0-.11l-.02-.07c-.05-.12-.12-.23-.22-.33L15.67.31c-.1-.08-.21-.15-.32-.2l-.4-.1H6.25c-1.56-.01-2.82,1.26-2.82,2.81v17.14c0,.61.5,1.11,1.11,1.11h14.57c1.56,0,2.82-1.27,2.82-2.82V6.86h0ZM16.54,8.21h3.18v10.04c0,.33-.27.61-.61.61H5.64V2.82c0-.33.27-.61.61-.61h7.46v3.18c0,1.56,1.27,2.82,2.82,2.82ZM15.93,5.39v-1.62l2.22,2.22h-1.62c-.33,0-.61-.27-.61-.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.71,14.82c0,.61.5,1.11,1.11,1.11h7.71c.61,0,1.11-.5,1.11-1.11s-.5-1.11-1.11-1.11h-7.71c-.61,0-1.11.5-1.11,1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.71,11.39c0,.61.5,1.11,1.11,1.11h6c.3,0,.57-.11.78-.32s.32-.49.32-.78c0-.3-.11-.57-.32-.78-.21-.21-.49-.32-.78-.32h-6c-.61,0-1.11.5-1.11,1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.54,22.29H2.82c-.33,0-.61-.27-.61-.61V4.54c0-.61-.5-1.11-1.11-1.11s-1.11.5-1.11,1.11v17.14c0,1.56,1.27,2.82,2.82,2.82h13.72c.61,0,1.11-.5,1.11-1.11s-.5-1.11-1.11-1.11Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpedientesBalken);
export default __webpack_public_path__ + "static/media/expedientes_BALKEN.bc926fdbab9ace8e3d9b1618e53f7912.svg";
export { ForwardRef as ReactComponent };